import HttpRequest from "./axios";
const Api = new HttpRequest();
export default Api;
